import React from 'react';
import { Leaf, Shield, Activity, Heart, Droplet } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductExplanation() {
  const ingredients = [{
    name: 'Mariendistel',
    desc: 'schützt und regeneriert die Magenschleimhaut',
    icon: <Shield className="w-6 h-6" data-id="element-70" />
  }, {
    name: 'Artischocke',
    desc: 'reguliert Gallenfluß, reduziert Übelkeit',
    icon: <Droplet className="w-6 h-6" data-id="element-71" />
  }, {
    name: 'Topinambur & Inulin',
    desc: 'stabilisieren die Darmflora nachhaltig',
    icon: <Activity className="w-6 h-6" data-id="element-72" />
  }, {
    name: 'Johannisbrotmehl',
    desc: 'beruhigt den Magen-Darm-Trakt',
    icon: <Heart className="w-6 h-6" data-id="element-73" />
  }, {
    name: 'Möhrenmehl',
    desc: 'natürlicher Magenschutz durch Pektine',
    icon: <Leaf className="w-6 h-6" data-id="element-74" />
  }];
  return <section className="py-16 md:py-24 bg-cardBg" data-id="element-75">
      <div className="max-w-4xl mx-auto px-4" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-77">
          <h2 className="font-serif text-3xl md:text-4xl text-forestGreen font-bold mb-6" data-id="element-78">
            Warum Hunde unter Übelkeit leiden –{' '}
            <br className="hidden md:block" data-id="element-79" />
            und was die Magenschleimhaut wirklich braucht
          </h2>
          <p className="font-serif text-lg text-warmBrown max-w-2xl mx-auto" data-id="element-80">
            Leerer Magen & Magensäure sind häufige Ursachen. Ein 100%
            pflanzlicher Ansatz ohne künstliche Zusätze kann hier sanft
            unterstützen.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-81">
          {ingredients.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: idx % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-cream p-6 rounded-xl shadow-sm border border-warmBrown/10 flex items-start gap-4" data-id="element-82">
              <div className="bg-forestGreen/10 p-3 rounded-full text-forestGreen shrink-0" data-id="element-83">
                {item.icon}
              </div>
              <div data-id="element-84">
                <h4 className="font-serif font-bold text-xl text-forestGreen mb-1" data-id="element-85">
                  {item.name}
                </h4>
                <p className="font-serif text-gray-700" data-id="element-86">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}